import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

type Log = {
  type: 'error' | 'info' | 'warning';
  message: string;
  date: string;
};

interface LogsViewerProps {
  logs: Log[];
}

export const LogsViewer: React.FC<LogsViewerProps> = ({ logs }) => {
  const getLogStyle = (type: string) => {
    switch (type) {
      case 'error':
        return { color: 'error.main', icon: <ErrorOutlineIcon color="error" /> };
      case 'info':
        return { color: 'info.main', icon: <InfoOutlinedIcon color="info" /> };
      default:
        return { color: 'text.secondary', icon: <InfoOutlinedIcon /> };
    }
  };

  const formatDate = (date: string) => new Date(date).toLocaleString();

  return (
    <Box sx={{ width: '100%', maxWidth: '100%', mx: 'auto', p: 2, bgcolor: 'background.paper', borderRadius: 2, boxShadow: 0 }}>
      <Stack spacing={2} divider={<Divider />}>
        {logs.map((log, index) => {
          const { color, icon } = getLogStyle(log.type);
          return (
            <Box key={index} sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <Box>{icon}</Box>
              <Box>
                <Typography variant="body1" sx={{ color }}>
                  {log.message}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {formatDate(log.date)}
                </Typography>
              </Box>
            </Box>
          );
        })}
      </Stack>
    </Box>
  );
};
